import { Button } from "."
import { cvResumeLink } from "./Sidebar"

type Props = {}

export const LandingPage = (props: Props) => {
  return (
    <section className="landing_container" id="landing">
      <span className="text-italic-open">{"<landing section>"}</span>
      <main>
        <p className="landing_welcome text-primary">
          <span className="holla">Holla 👋, I'm</span>
          {/* <span className='landing_name'>Muhyideen</span>, */}
          <span className="header_text">
            <span className="title">Muhyideen,</span>
            <span className="title">Muhyideen,</span>
          </span>
          {/* , */}
        </p>

        <p className="landing_summary text-primary" id="summary">
          A creative software engineer building
          <br />
          exceptional web & mobile experiences.
        </p>
        {/* <p id="the-logo" onClick={() => {
            // scrollFun("landing")
            // navigate("/")
        }}>
            MA
        </p> */}

        <a
          href={cvResumeLink}
          target="_blank"
          rel="noopener noreferrer"
          className="download-btn"
        >
          <Button text="View CV" btnType="primary" className="landing_btn" />
        </a>
      </main>

      <span className="text-italic-close">{"</landing section>"}</span>
    </section>
  )
}
